/**
 *
 * Asynchronously loads the component for SetPasswordModule
 *
 */

import { lazyLoad } from 'utils/loadable';

export const SetPasswordModule = lazyLoad(
  () => import('./index'),
  module => module.SetPasswordModule,
);
